<template>
  <div>
    <v-dialog v-model="showModal" v-if="modalCanBeShowed" :width="width" hide-overlay
              content-class="pt-3 px-3 notifications-dialog" transition="dialog-bottom-transition">
      <v-alert v-for="(notification, index) in persistentNotifications" v-bind:key="index" :type=notification.color outlined>
        <template v-for="(message, index) in notification.messages">
          {{ message }}<br :key="index" v-if="isNotLastMessage(notification.messages.length, index)">
        </template>
        <span slot="append" style="cursor:pointer;" @click="removeNotificationById(notification.id)">
          <v-icon>mdi-close</v-icon>
        </span>
      </v-alert>
    </v-dialog>
    <v-btn small dark elevation="0" icon @click="toggleShowModal" :disabled="emptyDialog">
      <v-badge :value="persistentNotificationsLength" dot top :color="badgeColor" overlap>
        <v-icon>{{ notificationsIcon }}</v-icon>
      </v-badge>
    </v-btn>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import { notificationMixin } from '../mixins';

export default {
  name: 'un-notifications-center',
  mixins: [notificationMixin],
  props: {
    notificationsIcon: { type: String, default: 'mdi-bell' },
    badgeColor: { type: String, default: 'red' },
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    ...mapGetters(['persistentNotifications']),
    width() {
      if (this.$vuetify.breakpoint.mdAndDown) return '90%';
      return '50%';
    },
    persistentNotificationsLength() {
      return this.persistentNotifications.length;
    },
    emptyDialog() {
      return this.persistentNotifications.length === 0;
    },
    modalCanBeShowed() {
      return this.persistentNotifications.length && this.showModal;
    }
  },
  methods: {
    ...mapActions(['removeNotificationById']),
    toggleShowModal() {
      this.showModal = !this.showModal;
    }
  },
  watch: {
    persistentNotificationsLength(updatedLength) {
      // If user has removed all notifications
      if (this.showModal && updatedLength === 0) this.showModal = false;
    },
    $route() {
      this.showModal = false;
    }
  },
};
</script>

<style>
.notifications-dialog {
  position: absolute;
  bottom: 40px;
  right: 0;
}
</style>
